<nz-slider
  [formControl]="control"
  [nzRange]="range"
  [nzDisabled]="disabled"
  [nzMax]="min"
  [nzMax]="max"
  [nzTooltipVisible]="nzTooltipVisible"
  (ngModelChange)="updateSlide($event)"
></nz-slider>

@if (showInputs) {
<div class="customInputs">
  <input
    class="start"
    type="number"
    [value]="start"
    nz-input
    nzBorderless
    [disabled]="!range"
    (change)="updateMin($event)"
  />
  <div></div>
  <input
    type="number"
    [value]="end"
    nz-input
    nzBorderless
    class="end"
    (change)="updateMax($event)"
  />
</div>
}
